
import React from "react";
import {Alert} from "react-bootstrap";

export default function ResponseAlert(props){



    return (
        <Alert className={"m-2"} show={props.show} variant={"danger"} >
            {props.error}
        </Alert>
    )
}


